<i class="icon-20 icon-mdi--arrow_drop_down" [@indicatorRotate]="(iconoDespliegueService.expandidoAsObservable| async) ? 'expanded': 'collapsed'"></i>